/* eslint-disable */
/** Carina Default (light theme) Formula
 * Use this formula to build a carina tokens object from a finalizedColorPalette
 * Copy and modify this formula to create a highly customized theme
 *
 * @param  {object} finalizedColorPalette Carina palette example: finalizeColorPalette(createColorPalette())
 * @returns {object} carina default (light theme) tokens object
 */

/* "...FORMULA-OBJECT" tags are used by docsite to locate the tokens object */
// prettier-ignore
// eslint-disable-next-line prettier/prettier
module.exports = ({ default: palette }) => (/* START-FORMULA-OBJECT */ {
  colors: {
    neutral: palette.neutral,
    brand: palette.brand,
    interactive: palette.interactive,
    accent: palette.accent,
    tertiary: palette.tertiary,
    danger: palette.danger,
    warning: palette.warning,
    success: palette.success,
    accessory: {
      1: palette.accessoryOne,
      2: palette.accessoryTwo,
      3: palette.accessoryThree,
      4: palette.accessoryFour,
      5: palette.accessoryFive
    }
  },
  backgroundColor: {
    base: palette.neutral.zero,
    active: palette.neutral[15],
    focus: palette.neutral[10],
    hover: palette.neutral[10],
    surface: palette.neutral[10],
    disabled: palette.neutral.zero,
    neutral: {
      base: palette.neutral.zero,
      active: palette.neutral[30],
      focus: palette.neutral[10],
      hover: palette.neutral[30],
      surface: palette.neutral[150],
      disabled: palette.neutral[10],
      fill: {
        base: palette.neutral[45],
        hover: palette.neutral[100],
        active: palette.neutral[100],
        focus: palette.neutral[30],
        surface: palette.neutral[70],
        disabled: palette.neutral[15]
      }
    },
    interactive: {
      base: palette.neutral.zero,
      active: palette.interactive[15],
      focus: palette.interactive[10],
      hover: palette.interactive[10],
      surface: palette.interactive[13],
      disabled: palette.interactive.zero,
      fill: {
        base: palette.interactive[45],
        hover: palette.interactive[70],
        active: palette.interactive[100],
        focus: palette.interactive[70],
        surface: palette.interactive[15],
        disabled: palette.interactive[45]
      }
    },
     /* Tokens 2021 update from UX includes changing values of brand stacks.
      instead of updating here, we've opted to create 2 new more semantically-named stacks,
      which can be found in the @cvent/carina-tokens package
    */
    brand: {
      base: palette.neutral.zero,
      active: palette.brand[15],
      focus: palette.brand[10],
      hover: palette.brand[10],
      surface: palette.brand[10],
      disabled: palette.neutral[15],
      fill: {
        base: palette.brand[45],
        hover: palette.brand[70],
        active: palette.brand[100],
        focus: palette.brand[30],
        surface: palette.brand[10],
        disabled: palette.neutral[15]
      }
    },
    accent: {
      base: palette.neutral.zero,
      active: palette.accent[15],
      focus: palette.accent[10],
      hover: palette.accent[10],
      surface: palette.accent[13],
      disabled: palette.accent.zero,
      fill: {
        base: palette.accent[30],
        active: palette.accent[70],
        focus: palette.accent[45],
        hover: palette.accent[45],
        surface: palette.accent[15],
        disabled: palette.accent[30]
      }
    },
    tertiary: {
      base: palette.neutral.zero,
      active: palette.tertiary[15],
      focus: palette.tertiary[10],
      hover: palette.tertiary[10],
      surface: palette.tertiary[13],
      disabled: palette.tertiary.zero,
      fill: {
        base: palette.tertiary[45],
        active: palette.tertiary[100],
        focus: palette.tertiary[70],
        hover: palette.tertiary[70],
        surface: palette.tertiary[15],
        disabled: palette.tertiary[45]
      }
    },
    danger: {
      base: palette.neutral.zero,
      active: palette.danger[15],
      focus: palette.danger[10],
      hover: palette.danger[10],
      surface: palette.danger[13],
      disabled: palette.danger.zero,
      fill: {
        base: palette.danger[45],
        active: palette.danger[100],
        focus: palette.danger[70],
        hover: palette.danger[70],
        surface: palette.danger[30],
        disabled: palette.neutral[15]
      }
    },
    warning: {
      base: palette.warning.zero,
      active: palette.warning[15],
      focus: palette.warning[10],
      hover: palette.warning[10],
      surface: palette.warning[10],
      disabled: palette.warning.zero,
      fill: {
        base: palette.warning[15],
        active: palette.warning[45],
        focus: palette.warning[30],
        hover: palette.warning[30],
        surface: palette.warning[13],
        disabled: palette.warning[15]
      }
    },
    success: {
      base: palette.neutral.zero,
      active: palette.success[15],
      focus: palette.success[10],
      hover: palette.success[10],
      surface: palette.success[13],
      disabled: palette.success.zero,
      fill: {
        base: palette.success[45],
        active: palette.success[100],
        focus: palette.success[70],
        hover: palette.success[70],
        surface: palette.success[15],
        disabled: palette.neutral[45]
      }
    }
  },

  borderColor: {
    base: palette.neutral[30],
    soft: palette.neutral[15],
    active: palette.neutral[30],
    focus: palette.neutral[30],
    hover: palette.interactive[45],
    disabled: palette.neutral[15],
    neutral: {
      base: palette.neutral[100],
      active: palette.neutral[100],
      focus: palette.interactive[45],
      hover: palette.neutral[70],
      disabled: palette.neutral[15],
      fill: {
        base: palette.neutral.zero,
        active: palette.neutral.zero,
        focus: palette.neutral.zero,
        hover: palette.neutral.zero,
        disabled: palette.neutral.zero,
        surface: palette.neutral[70]
      }
    },
    interactive: {
      base: palette.interactive[45],
      active: palette.interactive[100],
      focus: palette.interactive[30],
      hover: palette.interactive[70],
      disabled: palette.neutral[15]
    },
    brand: {
      base: palette.brand[45],
      active: palette.brand[100],
      focus: palette.brand[30],
      hover: palette.brand[70],
      disabled: palette.neutral[15]
    },
    accent: {
      base: palette.accent[45],
      active: palette.accent[100],
      focus: palette.accent[30],
      hover: palette.accent[70],
      disabled: palette.neutral[15]
    },
    tertiary: {
      base: palette.tertiary[45],
      active: palette.tertiary[100],
      focus: palette.tertiary[30],
      hover: palette.tertiary[70],
      disabled: palette.neutral[15]
    },
    danger: {
      base: palette.danger[45],
      active: palette.danger[100],
      focus: palette.danger[30],
      hover: palette.danger[70],
      disabled: palette.neutral[15]
    },
    success: {
      base: palette.success[45],
      active: palette.success[100],
      focus: palette.success[30],
      hover: palette.success[70],
      disabled: palette.neutral[15]
    },
    warning: {
      base: palette.warning[15],
      active: palette.warning.zero,
      focus: palette.warning[30],
      hover: palette.warning[10],
      disabled: palette.neutral[15]
    }
  },

  depth: {
    boxShadow: {
      soft: {
        xOffset: '0rem',
        yOffset: '0.5rem',
        blurRadius: '1.25rem',
        spreadRadius: '0rem',
        color: 'rgba(0, 0, 0, 0.06)'
      },
      hard: {
        xOffset: '0rem',
        yOffset: '0.25rem',
        blurRadius: '0.5rem',
        spreadRadius: '-0.125rem',
        color: 'rgba(0, 0, 0, 0.25)'
      },
      0: {
        xOffset: '0px',
        yOffset: '0px',
        blurRadius: '0px',
        spreadRadius: '0px',
        color: 'rgba(0, 0, 0, 0.0)'
      },
      1: {
        xOffset: '0px',
        yOffset: '0px',
        blurRadius: '12px',
        spreadRadius: '2px',
        color: 'rgba(0, 0, 0, 0.10)'
      },
      2: {
        xOffset: '0px',
        yOffset: '4px',
        blurRadius: '16px',
        spreadRadius: '-4px',
        color: 'rgba(0, 0, 0, 0.10)'
      },
      3: {
        xOffset: '0px',
        yOffset: '4px',
        blurRadius: '20px',
        spreadRadius: '0px',
        color: 'rgba(0, 0, 0, 0.20)'
      },
      4: {
        xOffset: '0px',
        yOffset: '4px',
        blurRadius: '20px',
        spreadRadius: '-2px',
        color: 'rgba(0, 0, 0, 0.25)'
      }
    },
    opacity: {
      transparent: 0,
      min: 0.3,
      light: 0.4,
      medium: 0.5,
      heavy: 0.8,
      max: 0.9,
      opaque: 1
    },
    zIndex: {
      100: '100',
      400: '400',
      800: '800',
      1600: '1600'
    }
  },
  icon: {
    /* use font.color to style icon colors */
    size: {
      s: '0.875rem',
      m: '1rem',
      l: '1.5rem',
      xl: '2rem'
    }
  },

  size: {
    border: {
      base: 1,
      focus: 2,
      active: 4,
      disabled: 1,
      radius: {
        twoX: '4px',
        threeX: '6px',
        fiveX: '10px',
        round: '100px'
      }
    }
  },

  transition: {
    duration: {
      default: '.3s'
    }
  },

  font: {
    color: {
      base: palette.neutral[150],
      soft: palette.neutral[45],
      fill: palette.neutral.zero,
      active: palette.neutral[100],
      focus: palette.neutral[100],
      hover: palette.neutral[100],
      disabled: palette.neutral[30],
      onLight: palette.neutral[150],
      onDark: palette.neutral.zero,
      neutral: {
        base: palette.neutral[45],
        fill: palette.neutral.zero,
        active: palette.neutral[100],
        focus: palette.neutral[30],
        hover: palette.neutral[70],
        disabled: palette.neutral[30]
      },
      interactive: {
        base: palette.interactive[45],
        fill: palette.neutral.zero,
        active: palette.interactive[100],
        focus: palette.interactive[30],
        hover: palette.interactive[70],
        disabled: palette.neutral[30]
      },
      brand: {
        base: palette.brand[45],
        fill: palette.neutral.zero,
        active: palette.brand[100],
        focus: palette.brand[30],
        hover: palette.brand[70],
        disabled: palette.neutral[30]
      },
      accent: {
        base: palette.accent[45],
        fill: palette.neutral.zero,
        active: palette.accent[100],
        focus: palette.accent[30],
        hover: palette.accent[70],
        disabled: palette.neutral[30]
      },
      tertiary: {
        base: palette.tertiary[45],
        fill: palette.neutral.zero,
        active: palette.tertiary[100],
        focus: palette.tertiary[30],
        hover: palette.tertiary[70],
        disabled: palette.neutral[30]
      },
      danger: {
        base: palette.danger[45],
        fill: palette.neutral.zero,
        active: palette.danger[100],
        focus: palette.danger[30],
        hover: palette.danger[70],
        disabled: palette.neutral[30]
      },
      success: {
        base: palette.success[45],
        fill: palette.neutral.zero,
        active: palette.success[100],
        focus: palette.success[30],
        hover: palette.success[70],
        disabled: palette.neutral[30]
      },
      warning: {
        base: palette.neutral.max,
        fill: palette.neutral.max,
        active: palette.neutral.max,
        focus: palette.neutral.max,
        hover: palette.neutral.max,
        disabled: palette.neutral[30]
      }
    },
    lineHeight: {
      heading: '1.25',
      prose: '1.6', // loose long form body text
      list: '1.25',
      base: '1.5' // default for everything else
    },
    base: {
      family: "'Rubik', 'Helvetica', 'Arial'",
      weight: {
        light: 300,
        regular: 400,
        bold: 500
      },
      size: {
        h1: '2.25rem',
        h2: '1.5rem',
        h3: '1.3125rem',
        h4: '1.125rem',
        h5: '0.875rem',
        h6: '0.75rem',
        l: '1.25rem', // 20
        m: '1rem', // 16
        s: '0.875rem', // 14
        xs: '0.8125rem', // 13
        xxs: '0.75rem', // 12
        0: '0.625rem',
        1: '0.75rem',
        2: '0.8125rem',
        3: '0.875rem',
        4: '1rem',
        5: '1.125rem',
        6: '1.25rem',
        7: '1.5rem',
        8: '1.875rem',
        9: '2.25rem',
        10: '3rem'
      }
    },
    prose: {
      family: "'Open Sans', 'Rubik', 'Helvetica', 'Arial', sans-serif",
      weight: {
        light: 400,
        regular: 400,
        bold: 700
      },
      size: {
        l: '1.25rem', // 20
        m: '1rem', // 16
        s: '0.875rem', // 14
        xs: '0.8125rem', // 13
        xxs: '0.75rem' // 12
      }
    },
    mono: {
      family: "'Roboto Mono', monospace",
      weight: {
        light: 400,
        regular: 400,
        bold: 400
      },
      size: {
        l: '1.25rem', // 20
        m: '1rem', // 16
        s: '0.875rem', // 14
        xs: '0.8125rem', // 13
        xxs: '0.75rem' // 12
      }
    }
  },
  animation: {
    expressive: {
      easeOut: {
        easing: 'cubic-bezier(0, 0, 0.39, 1)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      },
      easeIn: {
        easing: 'cubic-bezier(0.4, 0.14, 1, 1)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      },
      easeInOut: {
        easing: 'cubic-bezier(0.4, 0.15, 0.3, 1)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      }
    },
    productive: {
      easeOut: {
        easing: 'cubic-bezier(0, 0, 0.4, 0.9)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      },
      easeIn: {
        easing: 'cubic-bezier(0.2, 0, 1, 0.9)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      },
      easeInOut: {
        easing: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
        duration: {
          fastest: 100,
          fast: 200,
          medium: 400,
          slow: 550,
          slowest: 700
        }
      }
    },
    linear: {
      easing: 'cubic-bezier(0,0,1,1)',
      duration: {
        fastest: 100,
        fast: 200,
        medium: 400,
        slow: 550,
        slowest: 700
      }
    },
    delay: {
      fastest: 100,
      fast: 200,
      medium: 400,
      slow: 550,
      slowest: 700
    },
    transition: {
      duration: {
        default: '.3s'
      }
    },
    transform: {
      shrink: 'scale(0.96)',
      grow: 'scale(1.04)'
    }
  }
}/* END-FORMULA-OBJECT */);
